import { FC } from "react";
import { ReactCookieProps, withCookies } from "react-cookie";
import Erro404 from "../404";
import "react-phone-input-2/lib/style.css";
import { Props } from "../propTypes";
import { childFormComponent } from "./types";
import Phone from "./Phone";
import Email from "./Email";
// Phone or Email Form Component

interface PhoneEmailProps extends Props, childFormComponent, ReactCookieProps {}

const PhoneEmail: FC<PhoneEmailProps> = (props) => {
    if (props.showError404) {
        return (
            <Erro404 containerClass="flex flex-justify-center flex-align-center flex-column m-b-spacer-xl" />
        );
    }

    let Content = Phone;

    // show phone
    if (props.step === "email") {
        Content = Email;
    }

    return (
        <div>
            <h2 className="m-t-spacer-md m-b-spacer-none text-center font-size-24">
                {`What's your ${props.step === "email" ? "email" : "number"}?`}
            </h2>
            <p className="text-dark half-here m-b-spacer-xl text-center">
                We’ll send you a code to verify who you are.
            </p>
            <Content {...props} />
        </div>
    );
};

export default withCookies(PhoneEmail);
